import { FaArrowUp } from "react-icons/fa";
import ButtonLink from "../links/ButtonLink";
import { IHero } from "../../../store/@types/hero";
import React from "react";
// import PreloadImage from "../ImagePreloader/ImagePreloader";

const HeroSection: React.FC<IHero> = ({
  title,
  titleColor,
  description,
  descriptionColor,
  descriptionSpacing,
  buttonText,
  buttonLink,
  imageSrc,
  imgPlaceHolder,
  imageAlt,
  imagePosition = "right",
  imagePositionBgColor,
  imageRotation = "rotate-3",
  background,
  buttonbg,
  buttonTextColor,
  buttonHoverBg,
  paddingtop,
  xlSize = "xl:text-xl/relaxed",
}) => {
  // Detect if link is external
  const isExternal = /^https?:\/\//i.test(buttonLink?.trim());

  return (
    <section className={`w-full py-12 md:py-24 lg:py-32 ${background}`}>
      <div className={`max-w-7xl px-6 xl:px-0 ${paddingtop} mx-auto`}>
        <div
          className={`grid gap-6 lg:grid-cols-2 lg:gap-12 items-center ${
            imagePosition === "left" ? "lg:grid-flow-col-dense" : ""
          }`}
        >
          {/* Text Section */}
          <div
            className={`flex flex-col justify-center space-y-4 ${
              imagePosition === "right" ? "lg:order-first" : "lg:order-last"
            }`}
          >
            <div className="space-y-6">
              <h1
                className={`text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl ${titleColor}`}
              >
                {title}
              </h1>
              <div
                className={`w-full lg:max-w-[600px] md:text-xl/relaxed lg:text-base/relaxed ${xlSize} ${descriptionColor}`}
              >
                <div
                  dangerouslySetInnerHTML={{ __html: description }}
                  className={`${descriptionSpacing || ""}`}
                />
              </div>
            </div>

            {/* Button */}
            <div className="flex flex-col gap-2 min-[400px]:flex-row">
              {isExternal ? (
                <a href={buttonLink} target="_blank" rel="noopener noreferrer">
                  <ButtonLink
                    className={`group relative text-md font-medium transition ease-in-out duration-300 ${buttonbg} ${buttonTextColor}`}
                    link={buttonLink}
                  >
                    <span
                      className={`absolute inset-0 w-full h-full transition-all duration-300 ease-out transform -translate-x-full group-hover:translate-x-0 ${buttonHoverBg}`}
                    ></span>
                    <span className="relative mr-[2.5rem]">{buttonText}</span>
                    <div className="absolute right-1 top-1/2 transform -translate-y-1/2 transition-transform duration-300 ease-out group-hover:translate-x-0 bg-white p-3 rounded-full">
                      <FaArrowUp className="rotate-45 text-primary-900" />
                    </div>
                  </ButtonLink>
                </a>
              ) : (
                <ButtonLink
                  className={`group relative text-md font-medium transition ease-in-out duration-300 ${buttonbg} ${buttonTextColor}`}
                  link={buttonLink}
                >
                  <span
                    className={`absolute inset-0 w-full h-full transition-all duration-300 ease-out transform -translate-x-full group-hover:translate-x-0 ${buttonHoverBg}`}
                  ></span>
                  <span className="relative mr-[2.5rem]">{buttonText}</span>
                  <div className="absolute right-1 top-1/2 transform -translate-y-1/2 transition-transform duration-300 ease-out group-hover:translate-x-0 bg-white p-3 rounded-full">
                    <FaArrowUp className="rotate-45 text-primary-900" />
                  </div>
                </ButtonLink>
              )}
            </div>
          </div>

          {/* Image Section */}
          <div
            className={`relative mx-auto ${
              imagePosition === "left" ? "lg:order-first" : "lg:order-last"
            }`}
          >
            <div
              className={`absolute inset-0 rounded-2xl ${imagePositionBgColor} backdrop-blur-sm transform ${imageRotation} scale-105 dark:bg-green-800/30`}
            ></div>
            <img
              src={imageSrc || imgPlaceHolder}
              alt={imageAlt}
              width={550}
              height={550}
              className="relative mx-auto aspect-video overflow-hidden rounded-2xl object-cover object-center sm:w-full lg:aspect-square"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
